import React from 'react';
import styles from './styles.module.scss';
import { Link } from 'react-router-dom';
import { APP_PATHS } from '../../../constants';
import { useUserContext } from 'providers/user-context';
import classNames from 'classnames';
import useIsMobile from '../../../hooks/useIsMobile';

const Footer: React.FC = () => {
  const { user } = useUserContext();
  const isMobile = useIsMobile();

  const footerLinks = [
    { title: 'Terms of Service', path: APP_PATHS.TERMS },
    { title: 'Privacy Policy', path: APP_PATHS.PRIVACY },
    { title: 'About us', path: APP_PATHS.ABOUT_US },
    { title: 'Contact us', path: APP_PATHS.CONTACT_US }
  ];

  return (
    <div className={classNames(styles.wrapper, { [styles.noUser]: !user })}>
      <div className={styles.content}>
        <div className={styles.logoBlock}>
          <Link to={APP_PATHS.BASE} className={styles.logoLink}>
            <img src={'/images/logo.png'} alt="TonzOcash" />
          </Link>
  
          <div className={styles.logoTextGroup}>
            <p className={styles.copy}>© 2024 - 2025 TonzOcash. All rights reserved.</p>
            {/* In mobile show recaptcha text below links */}
            {!isMobile && (
              <p className={styles.recaptchaText}>
                This site is protected by reCAPTCHA and the Google{' '}
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                  Privacy Policy
                </a>{' '}
                and{' '}
                <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">
                  Terms of Service
                </a>{' '}
                apply.
              </p>
            )}
          </div>
        </div>
  
        <div className={styles.linkContainer}>
          {footerLinks.map((link, index) => (
            <Link key={index} to={link.path} className={styles.navLink}>
              {link.title}
            </Link>
          ))}
        </div>
        {isMobile && (
          <p className={styles.recaptchaText}>
            This site is protected by reCAPTCHA and the Google{' '}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>{' '}
            and{' '}
            <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">
              Terms of Service
            </a>{' '}
            apply.
          </p>
        )}
      </div>
    </div>
  );
            
};

export default Footer;